module.exports = __webpack_public_path__ + "static/3-Indoor-Golf-3842e1b39d5d834bd9c7cdc48d0fc7be.jpg";